"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = require("apollo-client");
function isApolloClient(client) {
    return client instanceof apollo_client_1.ApolloClient;
}
exports.isApolloClient = isApolloClient;
//# sourceMappingURL=isApolloClient.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-test-utils/dist/src/util/isApolloClient.js
// module id = 953
// module chunks = 0